import { Component, signal, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { ToastModule } from 'primeng/toast';
import { Supabase } from './services/supabase';
import { LoadingSpinner } from './components/loading-spinner/loading-spinner';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule,
    LoadingSpinner
  ],
  providers: [],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  readonly title = signal('triventa-app');
  private themeService = inject(ThemeService);
  private supabase = inject(Supabase);

  async ngOnInit() {
    this.themeService.setTheme('teal');
    
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const accessToken = hashParams.get('access_token');
    const refreshToken = hashParams.get('refresh_token');
    
    if (accessToken && refreshToken) {
      await this.supabase.getClient().auth.setSession({
        access_token: accessToken,
        refresh_token: refreshToken
      });
      
      window.location.hash = '';
    }
    
    // Check if current session is valid
    const { data: { session }, error: sessionError } = await this.supabase.getClient().auth.getSession();
    
    if (sessionError || (session && !session.user)) {
      // Invalid session - clear it
      await this.supabase.getClient().auth.signOut();
    }
  }
}
